import './App.css';
import { NotFoundPage, pageRoutes, usePathname } from './route';

function App() {
  const pathname = usePathname();
  const Page = pageRoutes[pathname] || NotFoundPage;

  return <Page />;
}

export default App;
